import {useStorage} from "@vueuse/core";
import {onMounted} from "vue";

export const useReferrerQueryParams = () => {
  const referrerCode = useStorage("rc", null);

  const getReferrerCodeFromQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("rc");
    const refError = urlParams.get("rce");

    if (refCode) {
      referrerCode.value = refCode;
      return;
    }

    if (refError === "1") toast.warning("Hmm, it looks like that referral code is no longer valid. Please contact whoever referred you.");
  };

  onMounted(() => getReferrerCodeFromQueryParams());

  return {
    referrerCode
  };
};
